// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentIconCardConditional on QuestionnaireQuestionChoiceOptionContentIconCardConditional {
  icon {
    ...imageLarge
  }
  title
  description
  conditions {
    ...questionnaireCondition
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireConditionFragmentDoc}`;